<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <ul
        class="items-center gap-x-3 grid"
        style="grid-template-columns: 0.6fr 0.7fr 1fr auto auto auto"
      >
        <el-form-item
          label="类型"
          prop="lx"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-select v-model="state.model.lx">
            <el-option
              v-for="item in state.lx_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadLx"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="日期"
          prop="date"
          :rules="[{ required: true, message: '请选择日期', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-date-picker
            v-model="state.model.date"
            type="date"
            placeholder="--请选择--"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item
          label="时间"
          prop="time"
          :rules="[{ required: true, message: '请选择时间', trigger: 'blur' }]"
          style="min-width: 0"
        >
          <el-time-picker
            v-model="state.model.time"
            is-range
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="HH:mm"
            format="HH:mm"
            :default-value="[
              new Date().setHours(8, 0, 0),
              new Date().setHours(18, 0, 0),
            ]"
            :save-on-blur="false"
          />
        </el-form-item>
        <el-form-item label="是否全员日程">
          <el-radio-group v-model="state.model.qyrc">
            <el-radio-button label="是" :value="1" />
            <el-radio-button label="否" :value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否需要签到">
          <el-radio-group v-model="state.model.xyqd">
            <el-radio-button label="是" :value="1" />
            <el-radio-button label="否" :value="0" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否网站显示">
          <el-radio-group v-model="state.model.wzxs">
            <el-radio-button label="是" :value="1" />
            <el-radio-button label="否" :value="0" />
          </el-radio-group>
        </el-form-item>
      </ul>
      <el-form-item
        label="所属会场"
        prop="hc_id"
        :rules="[{ required: true, message: '请选择会场', trigger: 'blur' }]"
      >
        <el-select v-model="state.model.hc_id">
          <el-option
            v-for="item in state.hc_data"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadHc"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="说明">
        <el-input v-model="state.model.sm" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      onLoadLx();
      onLoadHc();
      if (props.id) {
        onLoadDetail();
      }
    });

    //加载类型
    const onLoadLx = () => {
      state.lx_data = [
        {
          id: 1,
          name: "会议",
        },
        {
          id: 2,
          name: "培训",
        },
        {
          id: 3,
          name: "活动",
        },
      ];
    };

    //加载会场
    const onLoadHc = () => {
      state.hc_data = [
        {
          id: 1,
          name: "会场1",
        },
        {
          id: 2,
          name: "会场2",
        },
        {
          id: 3,
          name: "会场3",
        },
      ];
    };

    //加载详情
    const onLoadDetail = () => {};

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
          } else {
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadLx,
      onLoadHc,
      onLoadDetail,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
